export const cookiesAllConsent = {
  kr: `<div>HYBE IM과 그 파트너사는 쿠키 및 유사 기술(통칭하여 "기술")을 사용하여 사용자의 기기에 정보를 저장하고 접근합니다. 
안전하고, 제대로 작동하며, 신뢰할 수 있는 웹사이트를 제공하기 위해 이들 중 일부 기술은 필수적입니다. 
당사는 최상의 사용자 환경을 제공하기 위해 선택적/비필수 기술을 설정하고자 합니다. 

선택적 기술은 당사 웹사이트 사용자의 통계를 측정하고, 사용자의 프로필을 기반으로 타사 사이트에 맞춤형 광고를 표시하고, 사용자의 위치를 추적하고, 타겟팅된 마케팅 캠페인을 실행하고,개인의 사용 패턴에 따라 당사 웹사이트의 콘텐츠를 개인화할 수 있게 합니다. 당사는 이러한 기술을 통해 사용자와 당사 웹 사이트 간의 상호 작용, 선호도 및 검색 습관과 같은 정보를 수집합니다.
이러한 목적으로 기술을 사용하는 데 동의하시면 "모두 수락"을 클릭하여 모든 기술의 사용을 수락하세요. 

또한 아래와 같이 어떤 쿠키들을 귀하의 기기에 설정할지 관리할 수 있습니다. 웹 사이트 하단의 "쿠키 환경 설정" 아이콘을 클릭하면 언제든지 설정을 변경할 수 있습니다.
선택한 옵션은 12개월 동안 유지됩니다. 

자세한 내용은 당사의 <a href="/kr/policy/cookies" target="_blank" class="underline text-bold">쿠키 정책</a> 및 <a href="/kr/policy/privacy-policy" target="_blank" class="underline text-bold">개인정보 보호정책</a>에서도 확인할 수 있습니다.
</div>
  `,
  en: `
   <div>HYBE IM, and its partners, use cookies and similar technologies (collectively “technologies”) to store and access information on your device. 
Some of these technologies are technically essential to provide you with a secure, well-functioning and reliable website.
We would also like to use optional/non-essential technologies to give you the best user experience. 
The optional technologies make it possible to analyse the audience of our website, to display personalized advertising on third-party sites based on your profile, to track your location, to carry out targeted marketing campaigns and to personalize the content of our website depending on your usage.
 
Through these technologies, we will collect information such as the interactions between you and our website, your preferences and your browsing habits.
If you are happy for technologies to be used for these purposes, click on "Accept All" to accept all of the technologies. 

You are also able to manage which cookies can be used on your device below. 
You can change your preferences at any time by clicking on the "Cookie Preferences" icon at the bottom of our website.
Your choice will be retained for 12 months.
  
  Further information is also available in our <a href="/en/policy/cookies" target="_blank" class="underline text-bold">Cookie Policy</a> and our <a href="/en/policy/privacy-policy" target="_blank" class="underline text-bold">Privacy Policy</a>.
   </div>
  `,
  jp: `
   <div>HYBE IMとそのパートナー会社は、クッキー及び類似技術（通称「技術」という）を使用してユーザーのデバイスに情報を保存し、アクセスします。これらの技術の一部は、安全かつ正常に作動し、信頼できるウェブサイトを提供するためには必ず必要です。
   当社は最高のユーザー環境を提供するために、選択的・非必須技術を設定します。
   選択的技術は、当社ウェブサイトのユーザーの統計をとり、ユーザーのプロフィールをベースとして他社のウェブサイトにターゲット広告を表示します。
   また、ユーザーの位置を追跡し、ターゲティングされたマーケティングキャンペーンを実施して、個人の使用パターンによって当社ウェブサイトのコンテンツをパーソナライズできるようにします。
   当社はこのような技術を通じて、ユーザーと当社ウェブサイトの相互作用や好み、検索習慣のような情報を収集します。 
このような目的の技術使用に同意される場合は「すべて許可」をクリックし、すべての技術の使用を許可してください。また、以下のように、特定のクッキーを自分のデバイスに保存するかどうかを管理できます。
ウェブサイト下段の「クッキー環境設定」アイコンをクリックすると、いつでも設定を変更できます。選択したオプションは12ヶ月間維持されます。

詳しい内容は、当社の <a href="/jp/policy/cookies" target="_blank" class="underline text-bold">クッキーポリシー</a> と <a href="/jp/policy/privacy-policy" target="_blank" class="underline text-bold">プライバシーポリシー</a>でも確認できます。       
          </div>
  `,
};
